const actions = {
  SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORDS: 'SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORDS',
  SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORDS_ENDED:
    'SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORDS_ENDED',
  SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORD_LOGS:
    'SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORD_LOGS',
  SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORD_LOGS_ENDED:
    'SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORD_LOGS_ENDED',
};
export default actions;
